import React, {FC, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormGroup,
  TextField
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {apiCreateUser} from "../../api/users/api";
import {toast} from "react-toastify";
import {ErrorHelper} from "../../helper/errors";

export interface Props {
  open: boolean,
  setOpen: (open: boolean) => void,
  onSubmit?: () => void,
}
export const CreateUserDialog: FC<Props> = ({open, setOpen, onSubmit}) => {
  const {t} = useTranslation();
  const [firstName, setFirstName] = useState("");
  const [insertion, setInsertion] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const resetForm = () => {
    setFirstName("");
    setInsertion("");
    setLastName("");
    setEmail("");
  };

  const handleSubmit = () => {
    apiCreateUser({
      first_name: firstName,
      insertion,
      last_name: lastName,
      email
    }).then(() => {
      if (onSubmit) {
        onSubmit();
      }

      toast.success(t("USER_CREATED"));
      resetForm();
      handleClose();
    }).catch((result) => {
      ErrorHelper.toastLaraFail(result);
    });
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t("CREATE_USER")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("CREATE_USER_EXPLANATION")}</DialogContentText>
        <form onSubmit={handleSubmit} className={"settingsForm"}>
          <FormGroup>
            <TextField label={t("FIRST_NAME")} type={"text"} value={firstName} onChange={e => setFirstName(e.target.value)} />
            <TextField label={t("INSERTION")} type={"text"} value={insertion} onChange={e => setInsertion(e.target.value)} />
            <TextField label={t("LAST_NAME")} type={"text"} value={lastName} onChange={e => setLastName(e.target.value)} />
            <TextField label={t("EMAIL")} type={"text"} value={email} onChange={e => setEmail(e.target.value)} />
          </FormGroup>
        </form>
      </DialogContent>
      <DialogActions>
        <Button className={"submit"} variant={"contained"} type={"submit"} onClick={handleSubmit}>{t("SUBMIT")}</Button>
        <Button onClick={handleClose}>{t("CANCEL")}</Button>
      </DialogActions>
    </Dialog>
  );
}
